import localforage from 'localforage';

const API_BASE_URL = process.env.REACT_APP_GRAPHQL_SERVER_BASE_URL || 'http://localhost';

const authHeaders = async () => {
  const token = await localforage.getItem('otx_a');
  return {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    Authorization: `Bearer ${token}`
  };
};

/**
 * Cotización del checkout con el beneficio de organización (auto por membresía):
 * POST /api/checkout/quote { plan_id }.
 * @param {number|string} planId
 * @returns {Promise<{base_price:number, discount_percent:number, discount_amount:number, discounted_price:number, currency:string, source:string|null, organization_name:string|null}>}
 */
const getQuote = async (planId) => {
  const response = await fetch(`${API_BASE_URL}/api/checkout/quote`, {
    method: 'POST',
    headers: await authHeaders(),
    body: JSON.stringify({ plan_id: planId })
  });
  if (!response.ok) {
    return { discount_percent: 0, source: null };
  }
  return response.json();
};

export default { getQuote };
